import type { EstimatedTimeNameRef } from '@gat-ship/types'
import { getEstimatedTimeNamesRequest } from '../model/estimated-time-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/** Shared estimated-time-name ref cache for select/combobox pickers. */
export const estimatedTimeRefDataSource =
  createListRefDataSource<EstimatedTimeNameRef>({
    fetch: getEstimatedTimeNamesRequest,
    debounceMs: 0
  })
